import * as pubsub from "@avinet/adaptive-ui-core/utils/pubsub";

export interface PubsubTopicMap {
  application: {
    event: "created" | "updated" | "deleted";
    id: string;
  };
  data: {
    event: "created" | "updated" | "deleted";
    dataset: string;
    id?: unknown;
    result?: Record<string, unknown>;
  };
  export: {
    action: "showDialog";
    dataset: string;
    ids?: unknown[];
  };
  dataset: {
    event: "created" | "updated" | "deleted";
    id: string;
    dataProvider: string;
  };
  dataprovider: {
    event: "created" | "updated" | "deleted";
    id: string;
  };
  user: {
    event: "created" | "updated" | "deleted";
    id: string;
  };
  group: {
    event: "created" | "updated" | "deleted";
    id: string;
  };
  permissions: {
    event: "updated";
    scope: string;
  };
  maplayer: {
    event: "created" | "updated" | "deleted";
    id: string;
  };
}

export type PubsubTopic = keyof PubsubTopicMap;

/**
 * Subscribe to notifications about a specific topic.
 *
 * @param topic - The topic to subscribe to.
 * @param listener - The callback triggered when topic is published to.
 * @returns The unsubscribe method.
 */
export function subscribe<T extends PubsubTopic = PubsubTopic>(
  topic: T,
  listener: (message: PubsubTopicMap[T]) => void
) {
  return pubsub.subscribe(topic, listener);
}

/**
 * Publish a notification about a specific topic.
 *
 * Topic naming is app specific, but it is recommended to follow a `<category>/<event>` pattern (e.g. `document/created`, `document/deleted`), and provide specific details (like document ID) as a message.
 *
 * @param topic - The topic. Must be globally unique in your application.
 * @param message - The message. Should be an object with properties detailing the event, but this is optional and up to the application.
 * @returns
 */
export function publish<T extends PubsubTopic = PubsubTopic>(
  topic: T,
  message: PubsubTopicMap[T]
) {
  pubsub.publish(topic, message);
}
